// extracted by mini-css-extract-plugin
export default {"eventList":"ListEventCardGroup-module__eventList___U07UI"};